// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"styles__contextMenu___1k9h_"};